module.exports = __webpack_public_path__ + "static/media/logo-workflux-portal.5da2ee5c.svg";